import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { Chips, Mark } from '../../../../Component/Layouts/Web/Student/WebUi';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { WEB_BASE } from '../../../../Component/Layouts/Web/Student/WebLayout';
import { jobs } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Job = () => {
  const navigate = useNavigate();
  const { chips, saved, markSaved } = useWeb();
  const visible = jobs.filter((job) => chips.jobs === 'All' || job.type === chips.jobs);

  return (
    <>
      <div className="web-h">
        <div>
          <h1>Jobs & internships</h1>
          <p>Roles that match the skills you are building.</p>
        </div>
      </div>
      <Chips group="jobs" options={['All', 'Jobs', 'Internship']} />
      <div className="web-search web-row" style={{ marginBottom: 16 }}>
        <Icon name="search" />
        <span>Search jobs, internships…</span>
      </div>
      <div className="web-grid two">
        {visible.map((job) => {
          const applied = Boolean(saved[job.id]);
          return (
            <article className="web-card web-row" key={job.id}>
              <Mark name={job.icon} from={job.from} to={job.to} />
              <div className="web-grow">
                <b>{job.title}</b>
                <div className="web-mut">{job.company}</div>
                <div className="web-mut web-row" style={{ gap: 4 }}><Icon name="pin" /> {job.meta}</div>
                <div>{job.tags.map((tag) => <span className="web-tag" key={tag}>{tag}</span>)}</div>
              </div>
              <button type="button" className={`web-btn${applied ? ' ok' : ''}`} onClick={() => markSaved(job.id, 'Application started')}>
                {applied ? 'Applied' : 'Apply'}
              </button>
            </article>
          );
        })}
      </div>
      <div className="web-card web-row" style={{ marginTop: 16 }}>
        <Icon name="user" />
        <div className="web-grow">
          <b>Not getting relevant jobs?</b>
          <div className="web-mut">Update your profile and skills.</div>
        </div>
        <button type="button" className="web-btn" onClick={() => navigate(`${WEB_BASE}/profile`)}>Update now</button>
      </div>
    </>
  );
};

export default Job;
